import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import themeStyles from './MobileLayout.styles';

const AddressContainer = themeStyles.apply(Box, 'AddressContainer');
const LocationText = themeStyles.apply(Copy, 'LocationText');
const EditLocationCTA = themeStyles.apply(Copy, 'EditLocationCTA');

const EditAddressBar = ({ locationLabel, buttonLabel, handleShowModal, hasBorder }) => (
  <AddressContainer data-testid="cy-address-bar" hasBorder={hasBorder}>
    <LocationText data-testid="cy-location-text">{locationLabel}</LocationText>
    <EditLocationCTA onClick={handleShowModal} data-testid="cy-edit-location-cta">
      {buttonLabel}
    </EditLocationCTA>
  </AddressContainer>
);

EditAddressBar.propTypes = {
  locationLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  handleShowModal: PropTypes.func,
  hasBorder: PropTypes.bool,
};

export default EditAddressBar;
